<template>
    <div v-if="doc"
         class="f-col w-full space-y-0.75 approval-description">
        <!-- Type -->
        <field
            label="Тип:"
            :label-width="labelWidth"
            :value="doc.translated_type" />

        <!-- Chapter -->
        <field
            label="Раздел:"
            :label-width="labelWidth"
            :value="`${doc.chapter || 'Раздел не указан'}`" />

        <!-- Code -->
        <field label="Шифр:"
               :label-width="labelWidth"
               :value="`${doc.code || 'Шифр не указан'}`" />

        <!-- Version -->
        <field
            label="Версия:"
            :label-width="labelWidth"
            :is-version="true"
            :value="version" />

        <!-- Status -->
        <field
            label="Статус:"
            :label-width="labelWidth">
            <el-tag class="w-min"
                    :type="statusTag.type"
                    size="mini">
                {{ statusTag.label }}
            </el-tag>
        </field>

        <!-- Date upload -->
        <field
            label="Дата загрузки:"
            :label-width="labelWidth"
            :value="info.created_at | dateFormat(timeZone, 'dd MMMM y')" />

        <!-- Project -->
        <field
            label="Привязан к объекту:"
            :label-width="labelWidth"
            :value="projectName" />

        <field v-if="creator"
               label="Проектировщик"
               :label-width="labelWidth">
            <user-thumb :user="creator"
                        with-organization />
        </field>

        <field v-if="gip"
               label="ГИП"
               :label-width="labelWidth">
            <user-thumb :user="gip"
                        with-organization />
        </field>

        <el-button
            type="primary"
            icon="el-icon-view"
            size="mini"
            @click="handleOpenDoc">
            Открыть
        </el-button>

        <el-button
            size="mini"
            :body-style="{ marginLeft: 0 }"
            icon="el-icon-download"
            @click="handleDownloadDoc(doc)">
            Скачать
        </el-button>

        <portal-target name="approval-actions" />
    </div>
</template>
<script>
import Field from '@/components/approval/ApprovalDescriptionField.vue';
import downloadFile from 'js-file-download';
import {mapActions, mapGetters} from 'vuex';
import UserThumb from '@/components/users/UserThumb.vue'
import { getChiefProjectDesigner, getLastStampPromise, getProjectDesignerUser } from '@/models/tasks';

export default {
  name: 'ApproveDescription',
  components: {
    // ApprovalCreator,
    Field,
    UserThumb
  },
  props: {
    info: {
      type: Object,
      default: null
    },
    doc: {
      type: Object,
      default: null
    },
    projectName: {
      type: String,
      default: null
    },
    gipOrApprover: {
      type: Object,
      default: null
    },
    getPdfData: {
      type: Function,
      required: true
    },
    version: {
      type: String,
      required: true
    },
    task: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      labelWidth: 12
    };
  },
  computed: {
    ...mapGetters('approval', ['currentIteration']),

    statusTag() {
      switch (this.info?.process_status) {
      case null:
      case 'on_review': return { label: 'Ожидание согласования', type: 'warning' }
      case 'approved': return { label: 'Согласовано', type: 'success' }
      case 'on_cpe_approval': return { label: 'На согласовании у ГИП', type: '' }
      case 'stopped': return { label: 'Остановлено проектировщиком', type: 'danger' }
      case 'not_initialized': return { label: 'Не инициализирован', type: 'warning' }
      default: return { label: 'Отклонено', type: 'danger' }
      }
    },

    creator() {
      return getProjectDesignerUser(this.task)
    },

    gip() {
      return getChiefProjectDesigner(this.task)
    },

    lastStampPromise() {
      return getLastStampPromise(this.task)
    },

    stampPromiseStatus() {
      return this.lastStampPromise && this.lastStampPromise.status
    },

    stampPromiseStatusTag() {
      switch (this.stampPromiseStatus?.value) {
      case null: return {}
      case 'completed': return { label: 'Штамп есть', type: 'success' }
      default: return { label: 'Проштамповка', type: '' }
      }
    }
    
  },
  methods: {
    ...mapActions('project', ['downloadProjectDocument']),
    ...mapActions({
      setSelectedBim: 'bimViewer/SET_SELECTED_BIM'
    }),

    fileExtension(file) {
      let split = file?.original_file_name?.split('.') || [];
      return file?.bim_model ? 'bim' : split[split.length - 1];
    },
    async handleOpenDoc() {
      if (this.fileExtension(this.doc) !== 'pdf') return;

      try {
        this.$emit('changeLoading', true);
        let data = await this.downloadProjectDocument({
          projectId: this.$route.params.projectId,
          projectDocumentId: this.doc.id
        });

        const blob = new Blob([data], { type: 'application/pdf' });

        this.getPdfData(URL.createObjectURL(blob))
      } catch (e) {
        console.log(e);
        this.$notify({
          type: 'error',
          title: 'При загрузке произошла ошибка'
        });
      } finally {
        this.$emit('changeLoading', false);
      }
    },
    async handleDownloadDoc(projectDocument) {
      try {
        this.$emit('changeLoading', true);

        let data = await this.downloadProjectDocument({
          projectId: this.$route.params.projectId,
          projectDocumentId: projectDocument.id
        });

        downloadFile(data, this.currentIteration.document_name);
      } catch (e) {
        console.log(e);
        this.$notify({
          type: 'error',
          title: 'При загрузке произошла ошибка'
        });
      } finally {
        this.$emit('changeLoading', false);
      }
    }
  }
};
</script>
<style lang="scss">
.approval-description {
  button {
    margin-left: 0 !important;
    font-weight: 600;
  }

  .el-loading-spinner {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;

    & .circular {
      height: 20px;
      width: 20px;
    }
  }

  .el-loading-spinner {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;

    & .circular {
      height: 20px;
      width: 20px;
    }
  }
}
</style>
